import type { ReactNode } from 'react';
import type { ApiState } from '@/lib/useApi';
import { Button } from '@/components/ui/Button';
import { Alert, Spinner } from '@/components/ui/Feedback';

interface ApiStateViewProps<T> {
  state: ApiState<T>;
  onRetry?: () => void;
  loadingLabel?: string;
  retryLabel?: string;
  children: (data: T) => ReactNode;
}

/** Einheitliche Darstellung für Laden / Fehler / Daten. */
export function ApiStateView<T>({
  state,
  onRetry,
  loadingLabel = 'Wird geladen …',
  retryLabel = 'Erneut versuchen',
  children,
}: ApiStateViewProps<T>) {
  if (state.status === 'loading') {
    return <Spinner label={loadingLabel} />;
  }
  if (state.status === 'error') {
    return (
      <Alert tone="error">
        <p>{state.error.message}</p>
        {onRetry ? (
          <Button variant="ghost" size="sm" className="mt-2 -ml-3" onClick={onRetry}>
            {retryLabel}
          </Button>
        ) : null}
      </Alert>
    );
  }
  return <>{children(state.data)}</>;
}
